import { render, staticRenderFns } from "./CategoriesCarousel.vue?vue&type=template&id=c6bcf11c&"
import script from "./CategoriesCarousel.vue?vue&type=script&lang=js&"
export * from "./CategoriesCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports